// extracted by mini-css-extract-plugin
export default {"LoadingScreenDiv":"LoadingScreen_LoadingScreenDiv__GOPRE","blink":"LoadingScreen_blink__9G1vt","CloudAnimation":"LoadingScreen_CloudAnimation__A9JYA"};